/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 7/26/19
 *
 */

import Vue from "@/entry/setupVue3.js"

import {logError, tryReloadOnChunkLoadFailed} from "../utils/helpers"
import CommonObject from "@shared/CommonObject";

// if(isProdEnv) {
window.onerror = (message, source, line, column, error) => {
	if(message === "ResizeObserver loop limit exceeded"){
		// no need to report this error as explained here: https://stackoverflow.com/questions/49384120/resizeobserver-loop-limit-exceeded
		console.warn(message)
		return
	}
	console.error("window.onerror: error = ", error, "message = ", message)
	// return tryReloadOnChunkLoadFailed(error) || logError(error, source)
	return logError(error, source)
}
window.addEventListener("unhandledrejection", function (rejection) {
	console.error("unhandledrejection.onerror: rejection = ", rejection)
	return logError(rejection.reason)
});
Vue.config.errorHandler = (error, vm, info) => {
	console.error("Vue.config.errorHandler: error = ", error)
	console.error("Vue.config.errorHandler: info = ", info)
	if (error.name === 'ChunkLoadError') {
		// Handle the chunk load error
		console.error('ChunkLoadError: ', error.message);
		try{
			Vue.config.globalProperties.$analyticManager.trackEvent("Reload new version")
		} catch (e){
			console.error(e)
		}

		// Optionally, prompt the user to refresh the page
		if (confirm('A new version of the application is available. Click "ok" to refresh.')) {
			window.location.reload();
		}
	}
	return logError(error, info)
}

// }



